export default __webpack_public_path__ + "static/media/facebook.de1572e8.svg";